<!--
/**
* @name: Detail.vue
* @description: 返利管理-返利规则设置详情页面
* @author: 杨波
* @create: 2020/11/19 17:06:58
* @update: 2020/11/19 17:06:58
*/
-->
<template>
  <y-view :loading="isLoading">
    <y-form titleWidth="90px" contentWidth="100%" gutter="20px" titleAlign="left">
      <y-form-item title="任务编号：">{{ detail.rebateRuleNo }}</y-form-item>
      <y-form-item title="适用销售渠道：">{{ detail.saleChannelName }}</y-form-item>
      <y-form-item title="返利活动名称：">{{ detail.rebateRuleName }}</y-form-item>
      <y-form-item title="记录状态：">{{ detail.statusDesc }}</y-form-item>
      <y-form-item title="记录数量：">{{ detail.totalCount }}</y-form-item>
      <y-form-item title="有效数量：">{{ detail.validCount }}</y-form-item>
      <y-form-item title="已审核数量：">{{ detail.acceptedCount }}</y-form-item>
      <y-form-item title="创建时间：">{{ detail.createTime }}</y-form-item>
      <y-form-item title="开始生效时间：">{{ detail.startTime }}</y-form-item>
      <y-form-item title="结束生效时间：">{{ detail.endTime }}</y-form-item>
      <y-form-item title="返利规则信息：" align="top">
        <k-table :data="dataList" :columns="initColumns()"></k-table>
      </y-form-item>
    </y-form>
  </y-view>
</template>

<script>
import {
  NESTLE_FINANCE_BACK_SERVER_REBATE_RULE_DETAIL,
  NESTLE_FINANCE_BACK_SERVER_REBATE_RULE_REBATE_RULE_ITEM_ACCEPT,
  NESTLE_FINANCE_BACK_SERVER_REBATE_RULE_REBATE_RULE_ITEM_DISCARD,
} from "@/assets/modules/apiList";
export default {
  data() {
    return {
      isLoading: false,
      detail: {},
      dataList: [],
      recordId: "",
    };
  },
  methods: {
    initColumns() {
      return [
        {
          name: "商品货号",
          field: "goodsCodeSale",
          style: {
            width: 80,
            textAlign: "center",
            "white-space": "normal",
            "line-height": "18px",
          },
        },
        {
          name: "商品名称",
          field: "goodsNameSale",
          style: {
            width: 120,
            textAlign: "center",
            "white-space": "normal",
            "line-height": "18px",
          },
        },
        {
          name: "仓库",
          field: "wsname",
          style: {
            width: 80,
            textAlign: "center",
            "white-space": "normal",
            "line-height": "18px",
          },
        },
        {
          name: "批次号",
          field: "saleBatchNo",
          style: {
            width: 150,
            textAlign: "center",
            "white-space": "normal",
            "line-height": "18px",
          },
        },
        {
          name: "门店等级",
          field: "shopGrade",
          style: {
            width: 80,
            textAlign: "center",
          },
        },
        {
          name: "返利类型",
          field: "rebateTypeDesc",
          style: {
            width: 80,
            textAlign: "center",
          },
        },
        {
          name: "返利值",
          field: "rebateValue",
          style: {
            width: 80,
            textAlign: "center",
          },
        },
        {
          name: "记录状态",
          field: "statusDesc",
          style: {
            width: 80,
            textAlign: "center",
          },
        },
        {
          name: "错误原因",
          field: "reason",
          style: {
            width: 100,
            textAlign: "center",
            "white-space": "normal",
            "line-height": "18px",
          },
        },
        {
          name: "操作",
          field: "",
          style: {
            width: 60,
            textAlign: "center",
          },
          customRender: (row) => {
            const auditButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onAudit(row);
                }}
              >
                审核
              </a>
            );
            const deleteButton = (
              <a
                href="javascript:void(0);"
                onClick={() => {
                  this.onDelete(row);
                }}
              >
                作废
              </a>
            );
            if (row.status == "2" && this.detail.status == "0") {
              return (
                <div>
                  {auditButton}&#12288;{deleteButton}
                </div>
              );
            }
          },
        },
      ];
    },
    onAudit(row) {
      this.$dialog({
        title: "提示",
        content: "是否确认审核此规则？",
        ok: () => {
          this.isLoading = true;
          this.$fetch({
            api: NESTLE_FINANCE_BACK_SERVER_REBATE_RULE_REBATE_RULE_ITEM_ACCEPT,
            para: { id: row.id },
          })
            .then((res) => {
              this.isLoading = false;
              this.getDetail(this.recordId);
            })
            .catch(() => {
              this.isLoading = false;
            });
        },
      });
    },
    onDelete(row) {
      this.$dialog({
        title: "提示",
        content: "是否确认作废此规则？",
        ok: () => {
          this.isLoading = true;
          this.$fetch({
            api: NESTLE_FINANCE_BACK_SERVER_REBATE_RULE_REBATE_RULE_ITEM_DISCARD,
            para: { id: row.id },
          })
            .then((res) => {
              this.isLoading = false;
              this.getDetail(this.recordId);
            })
            .catch(() => {
              this.isLoading = false;
            });
        },
      });
    },
    getDetail(id) {
      this.$fetch({
        api: NESTLE_FINANCE_BACK_SERVER_REBATE_RULE_DETAIL,
        para: { id },
      }).then((res) => {
        this.detail = res;
        this.dataList = res.items || [];
      });
    },
  },
  created() {
    const { id } = this.$route.query;
    this.recordId = id;
    if (id) {
      this.getDetail(id);
    }
  },
  beforeRouteUpdate(to, from, next) {
    const { id } = to.query;
    this.recordId = id;
    this.detail = {};
    this.dataList = [];
    if (id) {
      this.getDetail(id);
    }
    next();
  },
};
</script>

<style lang="postcss" module="css"></style>
